module.exports = __webpack_public_path__ + "img/seguridadcanina.cf46c7d6.jpg";